import { render, staticRenderFns } from "./OcrPage.vue?vue&type=template&id=83213bce&scoped=true"
import script from "./OcrPage.vue?vue&type=script&lang=js"
export * from "./OcrPage.vue?vue&type=script&lang=js"
import style0 from "./OcrPage.vue?vue&type=style&index=0&id=83213bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83213bce",
  null
  
)

export default component.exports